// src/admin/customers/CustomerKpiStrip.jsx
import React from "react";

const KPI_DEFS = [
  {
    key: "all",
    label: "All Customers",
    getValue: (customers) => customers.length,
    color: "#6366F1",
    bg: "#EEF2FF",
  },
  {
    key: "active",
    label: "Active",
    getValue: (customers) => customers.filter((c) => c.status === "active").length,
    color: "#059669",
    bg: "#ECFDF5",
  },
  {
    key: "high_value",
    label: "High Value",
    getValue: (customers) => customers.filter((c) => c.totalSpend >= 30000).length,
    color: "#D97706",
    bg: "#FFFBEB",
  },
  {
    key: "flagged",
    label: "Flagged",
    getValue: (customers) => customers.filter((c) => c.status === "flagged").length,
    color: "#DC2626",
    bg: "#FEF2F2",
  },
  {
    key: "suspended",
    label: "Suspended",
    getValue: (customers) => customers.filter((c) => c.status === "suspended").length,
    color: "#64748B",
    bg: "#F1F5F9",
  },
];

export default function CustomerKpiStrip({ customers, activeKpi, onKpiClick }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: 12,
        marginBottom: 20,
      }}
    >
      {KPI_DEFS.map(({ key, label, getValue, color, bg }) => {
        const value = getValue(customers);
        const isActive = activeKpi === key;
        return (
          <button
            key={key}
            onClick={() => onKpiClick(key)}
            style={{
              background: isActive ? color : "#fff",
              border: isActive ? `1.5px solid ${color}` : "1px solid #E2E8F0",
              borderRadius: 12,
              padding: "14px 16px",
              textAlign: "left",
              cursor: "pointer",
              transition: "all 0.15s ease",
              boxShadow: isActive ? `0 4px 12px ${color}28` : "none",
            }}
          >
            <div
              style={{
                fontSize: 22,
                fontWeight: 800,
                color: isActive ? "#fff" : "#0F172A",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                letterSpacing: "-0.5px",
                marginBottom: 2,
              }}
            >
              {value}
            </div>
            <div
              style={{
                fontSize: 11.5,
                fontWeight: 600,
                color: isActive ? "rgba(255,255,255,0.8)" : "#94A3B8",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              {label}
            </div>
          </button>
        );
      })}
    </div>
  );
}